import { IConfigProps } from '../context/ConfigContext';
import { IFlowContextProps } from '../context/FlowContext';
import { BLOCK_TYPES, IChild, Model, ProductNames, Selection, TError } from './interfaces';

export enum EMAIL_IDENTIFIER {
    CAR_CALLME = 'CAR_CALLME',
    CHILD_CALLME = 'CHILD_CALLME',
    GENERAL_CALLME = 'GENERAL_CALLME', // USED FOR ERRORS ONLY
    CAR_SALES_COMPLETE = 'CAR_SALES_COMPLETE',
    CHILD_SALES_COMPLETE = 'CHILD_SALES_COMPLETE'
}

export type RMOEmailPayloadCommon = {
    identifier: EMAIL_IDENTIFIER;
    event: BLOCK_TYPES;
    fullName: string;
    phoneNumber: string;
    productName: ProductNames;
    operation?: string;
};

export type RMOEmailPayloadChild = {
    criticalIllnessCoverage?: boolean;
    birthDate?: string;
    disabilitySum?: number;
    packageName?: string;
    effectiveDate?: string;
    price?: string;
} & RMOEmailPayloadCommon;

export type RMOEmailPayloadCar = {
    registrationNumber?: string;
    manufacturer?: string;
    model?: string;
    fuelType?: string;
    enginePower?: string;
    motorSize?: string;
    vintage?: string;
    variant?: string;
    tariffGroup?: string;
    leasingCar?: boolean;
    address?: string;
    birthDate?: string;
    ownCarInsurance?: number;
    yearlyMillage?: string;
    packageName?: string;
    deductible?: string;
    additionalCoverages?: string[];
    numberOfClaims?: number;
    effectiveDate?: string;
    premiumRateDescription?: string;
} & RMOEmailPayloadCommon;

export interface IEmailPayload {
    identifier: EMAIL_IDENTIFIER;
    event?: BLOCK_TYPES;
    quoteId?: number;
    fullName?: string;
    cprNumber?: string;
    phoneNumber: string;
    emailAddress?: string;
    registrationNumber?: string;
    manufacturer?: string;
    model?: string;
    motorSize?: string;
    vintage?: string;
    fuelType?: string;
    enginePower?: string;
    variant?: string;
    vin?: string;
    partner?: string;
    leasingCar?: boolean;
    cpr?: string;
    birthDate?: string;
    address?: string;
    residentialAddress?: string;
    ownCarInsurance?: number;
    sameCompany?: string;
    numberOfClaims?: number;
    latestClaimYear?: number;
    yearlyMillage?: string;
    packageName?: string;
    deductible?: string;
    additionalCoverages?: string[];
    productName?: string;
    currentInsuranceCompany: string;
    otherCarInsuranceCompany?: string;
    effectiveDate?: string;
    premiumRateDescription?: string;
    bankRegistrationNumber?: string;
    bankAccountNumber?: string;
    eboks?: boolean;
    packageInfo?: string;
    children?: number;
    childrenInformation?: IChild[];
    price?: number;
    stakeholderMissing?: boolean;
}

export type SendRmoEMail = {
    config: IConfigProps;
    selection: Selection;
    model: Model;
    flow: IFlowContextProps;
    error: Omit<TError, 'dispatch'>;
    eventKey?: BLOCK_TYPES;
    logRMOError: (errorMessage: string) => void;
};
